import Marionette from "backbone.marionette";

import MenuTpl from "views/menu/menuView.ejs";
import CSS from "views/menu/menu.css";

import S from "session/session.js";
import T from "session/token.js";

require('jquery-equalheights');

export default Marionette
    .View
    .extend({
        initialize: function(data) {            
            this.parent = data.parent;
            this.listenTo(this.model, "sync", this.applyView.bind(this));
        },
        template: MenuTpl,
        render: function() {
            $("#loaderContainer").show();
            this
                .model
                .fetch({
                    data: {
                        instanceId: S.instanceId
                    },
                    beforeSend: T.useToken
                });
        },
        applyView: function() {
            //TODO: Change header image            
            S.enviroMenu = this.model.attributes.options;

            S.userInfo.attributes.options = []; //Does not trigger event
            S.userInfo.set({
                options: S.enviroMenu,
                lang: this.model.attributes.lang
            });

            $("#loaderContainer").hide();

            options = S.enviroMenu;
            var options;
            if (this.parent < 1000 && this.parent != 0) {

                _.each(S.enviroMenu, function(option) {
                    if (option.item === "EPIGRAFES" || option.item === "A_FUNC") {
                        for (var i in option.children) {
                            if (option.children[i].id == this.parent) {
                                options = option.children[i].children;
                            }
                        }
                    }
                }.bind(this));

            } else
                options = S.enviroMenu;

            this.$el.html(this.template({
                options: options,
                lang: this.model.attributes.lang,
                parent: this.parent
            }));

            $("a#USERS, a#ENVIRO, a#COMPANIES").parent().hide(); // Sidebar            
            $(".centFold").equalHeights({
                onResize: true,
                onLoad: false
            });

            // Remove active menu items
            $(".sidebar li").removeClass("active");
            $(".sidebar li > ul").removeClass("in");
            $(".sidebar li .submenu").removeClass("active").addClass("collapsed");
            $(".sidebar li .submenu").removeClass("in");
            if (this.parent && this.parent < 1000) {
                // EPIGRAPH && AREA FUNCIONAL
                $("#option" + this.model.attributes.areaId).addClass("active menu-open");
                $("#option" + this.model.attributes.areaId + " > ul").addClass("menu-open");
                // SUB EPIGRAPHS && SUB AREAS FUNCIONALES
                $("#AFUNC_" + this.parent).parent("li").addClass("active menu-open");
                $("#AFUNC_" + this.parent).parent("li > ul").addClass(" menu-open");
                $("#AREA_" + this.parent).parent("li").addClass('active menu-open');
                $("#AREA_" + this.parent).parent("li > ul").addClass('menu-open');
            } else {
                $("#option" + this.parent).addClass("active menu-open");
                $("#option" + this.parent + " > ul").addClass("menu-open");
            }


        },
        events: {
            "click .folder-select": "select"
        },
        select: function(ev) {
            var target = $(ev.currentTarget);
            var itemId = target.attr("data-id");
            var item = target.attr("data-item");
            var itemSlug = item.split('_')[0];
            var parentId = target.attr("data-parent");

            // Climb up parent
            if (itemId == -1) {
                // window.history.back();
                // window.top.location = "#menu/" + parentId;

                if (parentId > 1000) {
                    window.top.location = "#menu";
                    // window.history.back();
                } else {
                    window.top.location = "#menu/" + this.model.attributes.areaId;
                }
                return;
            }

            var found = false;
            _.each(this.model.attributes.options, function(option) {                
                if (option.id == itemId) {
                    //If parent folder
                    if (_.size(option.children)) {
                        window.top.location = "#menu/" + option.id;
                        found = true;
                        return;
                    } else {
                        window.top.location = "#" + option.item.toLowerCase();
                        found = true;
                        return;
                    }
                }

            });

            if (!found) {
                // window.top.location = "#" + $(ev.target).parent().attr("id").toLowerCase().replace("_", "/");                
                if ((item == "REGISTRALES") || (item == "CATASTRALES") || (item == "ACUERDOS") || (item == "TITULOS")) {
                    // window.top.location = "#" + $(ev.target).parent().attr("id").toLowerCase().replace("_", "/");
                    window.top.location = "#" + itemSlug.toLowerCase();
                } else if ((item == "REPORT_DETALLADOS") || (item == "REPORT_RESUMEN")) {
                    window.top.location = "#" + item.toLowerCase().replace("_", "/");
                } else {
                    window.top.location = "#" + itemSlug.toLowerCase() + "/" + itemId;
                }
            }
        }
    });


//////////////////
// WEBPACK FOOTER
// ./app/views/menu/menuView.js
// module id = 195
// module chunks = 0